import React, { useState } from "react";
import SoportePsicologico from './SoportePsicologico';
import Carrusel from './Carrusel';
import { Link } from 'react-router-dom';

const EncuentraAyuda = ({ id }) => {

    const [openModal, setOpenModal] = useState(null);
  
    const handleOpenModal = (modal) => setOpenModal(modal);
    const handleCloseModal = () => setOpenModal(null);

    const whatsappUrl1 = "https://wa.me/522221133330?text=Hola%20Psicóloga%20Diana%20Serrano,%20vengo%20del%20sitio%20Caminemos%20Juntas%20me%20gustaría%20tener%20una%20asesoría.";
    const whatsappUrl = "https://wa.me/529531776747?text=Hola%20Licenciada%20Gabriela%20Sarabia,%20vengo%20del%20sitio%20Caminemos%20Juntas%20me%20gustaría%20tener%20una%20asesoría.";


  return (
        <div id={id || 'EncuentraAyuda'}>
            <section className='grid grid-cols-1 gap-8 bg-[#f1f7f5] px-5 py-12 font-sans sm:px-8 lg:grid-cols-2 lg:px-12'>
                    <aside className="flex flex-col space-y-4 px-2 lg:px-8">
                    <p className='text-sm font-bold uppercase tracking-[0.16em] text-[#26756f]'>Primeros pasos</p>
                    <h2 className='mt-1 text-3xl font-bold text-[#173f46]'>Encuentra ayuda inmediata y segura</h2>
          <div className="flex items-center"> 
              <p className={'text-md font-thin text-gray-900 text-justify flex items-center justify-center'}>
                Si estás en peligro inmediato, llama al 911. Si puedes hacerlo de forma segura, consulta el directorio para encontrar atención psicológica, legal o un centro cercano.
              </p>
              
            </div>
            <p className={'text-md font-thin text-gray-900 text-justify flex items-center justify-center'}>
                            ¿Te sientes insegura o has vivido violencia? Puedes pedir orientación sin tener que explicar todo de una vez.
              </p>
                            <div className="flex flex-col gap-3 font-sans sm:flex-row sm:flex-wrap">
                                    <a href="tel:911" className="rounded-md bg-[#c94b4b] px-4 py-3 text-center font-semibold text-white hover:bg-[#a83e3e]"
                                    >
                                        Llamar al 911
                                    </a>
                                    <Link to="/numeros-de-emergencia" className="rounded-md bg-[#26756f] px-4 py-3 text-center font-semibold text-white hover:bg-[#1d5d58]">
                                        Buscar un centro
                                    </Link>
                                    <button className="rounded-md border border-[#26756f] px-4 py-3 font-semibold text-[#26756f] hover:bg-[#dceee9]"
                  onClick={() => handleOpenModal("solicitarAyuda")}
                  >
                                        Hablar con alguien
                  </button>
                                        <button
                                                className="rounded-md border border-[#26756f] px-4 py-3 font-semibold text-[#26756f] hover:bg-[#dceee9]"
                        onClick={() => handleOpenModal("verServicios")}
                    >
                                                Ver opciones
                    </button>
                    {openModal === "solicitarAyuda" && (
                        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                            <div className="bg-white rounded-lg p-4 shadow-lg max-w-sm w-full">
                                <h2 className="text-[#9775bb] text-xl font-bold mb-2">Solicitar Ayuda</h2>
                                <p className="mb-1 text-gray-500">
                                    <strong>Abogada Gabriela Sarabia</strong>
                                </p>
                                <div className="mb-6">
                                    <a
                                        href={whatsappUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="w-full py-2 px-2 text-white bg-green-500 rounded-lg hover:bg-green-600"
                                    >
                                        Contactarla por WhatsApp
                                    </a>
                                </div>
                                <p className="mb-1 text-gray-500">
                                    <strong>Psicóloga Diana Serrano</strong>
                                </p>
                                <div className=" mb-10">
                                    <a
                                        href={whatsappUrl1}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="w-full py-2 px-2 text-white bg-green-500 rounded-lg hover:bg-green-600"
                                    >
                                        Contactarla por WhatsApp
                                    </a>
                                </div>
                                <button
                                    className="py-2 px-4 w-full bg-black rounded-lg hover:bg-gray-300"
                                    onClick={handleCloseModal}
                                >
                                    Cerrar
                                </button>
                            </div>
                        </div>
                    )}

                    {openModal === "contactoEmergencia" && (
                        <div className="fixed inset-0 z-50  flex items-center justify-center bg-black bg-opacity-50">
                            <div className="bg-white rounded-lg p-4 shadow-lg max-w-sm w-full">
                                <h2 className="mb-2 text-xl font-bold text-[#173f46]">Contacto de emergencia</h2>
                                <p className="mb-4 text-gray-600">Para una emergencia inmediata en México, llama al 911.</p>
                                <a href="tel:911" className="mb-4 block rounded-md bg-[#c94b4b] px-4 py-3 text-center font-semibold text-white">Llamar al 911</a>
                                <Link to="/numeros-de-emergencia" onClick={handleCloseModal} className="block text-center font-semibold text-[#26756f]">Ver directorio de apoyo</Link>
                                <button
                                    className="py-2 px-4 w-full bg-black rounded-lg hover:bg-gray-300"
                                    onClick={handleCloseModal}
                                >
                                    Cerrar
                                </button>
                            </div>
                        </div>
                    )}

                    {openModal === "verServicios" && (
                        <div className="fixed inset-0 z-50  flex items-center justify-center bg-black bg-opacity-50">
                            <div className="bg-white rounded-lg p-4 shadow-lg max-w-sm w-full">
                                <h2 className="text-[#9775bb] text-xl font-bold mb-2">Servicios Disponibles</h2>
                                <ul className="list-disc list-inside mb-4 text-gray-500">
                                    <li>Asistente virtual 24/7</li>
                                    <li>Chat en vivo con profesionales</li>
                                    <li>Asesoría legal</li>
                                    <li>Asesoría psicológica</li>
                                </ul>
                                <button
                                    className="py-2 px-4 w-full bg-black rounded-lg hover:bg-gray-300"
                                    onClick={handleCloseModal}
                                >
                                    Cerrar
                                </button>
                            </div>
                        </div>
                    )}
                
                    
              </div>
      
              
          </aside>

                    <aside className="min-w-0">
              <Carrusel/>
          </aside>
        </section>
    </div>
  );
};

export default EncuentraAyuda;
